import React from "react";
import { Route, Routes } from "react-router";
import { Screens } from "@constants/screens";
import ErrorScreen from "@screens/ErrorScreen/ErrorScreen";
import NotFound from "@screens/NotFound/NotFound";
import TranslationsScreen from "@screens/TranslationsScreen/TranslationsScreen";
import MainLayout from "@shared/containers/Layout";
import { Redirect } from "@shared/router/Redirect/Redirect";

const RouterUser = (): React.JSX.Element => (
  <MainLayout>
    <Routes>
      {/* <Route path={Screens.RootAdmin.path()} element={<DashboardScreen />} />*/}
      <Route
        path={"*"}
        element={<Redirect from={"*"} to={Screens.Root.path()} />}
      />
      <Route path={Screens.Root.path()} element={<TranslationsScreen />} />
      <Route path={Screens.Error.path()} element={<ErrorScreen />} />
      <Route path={Screens.Any.path()} element={<NotFound />} />
    </Routes>
  </MainLayout>
);

export default RouterUser;
